import React from "react";

import type { SkillCollectionPreset } from "../skill-presets";
import { getFileLimitForProvider } from "../provider-config";

import { cn } from "@/lib/utils";

interface CharCountBarProps {
  provider: SkillCollectionPreset | null | undefined;
  relativePath: string;
  charCount: number;
}

export const CharCountBar = ({ provider, relativePath, charCount }: CharCountBarProps) => {
  const limitInfo = getFileLimitForProvider(provider, relativePath);
  if (!limitInfo) {
    return null;
  }

  const ratio = charCount / limitInfo.recommendedChars;

  const getCountColor = () => {
    if (ratio > 1) {
      return "text-red-600";
    }
    if (ratio > 0.8) {
      return "text-amber-600";
    }
    return "text-gray-500";
  };

  return (
    <div className="flex items-center justify-between border-t border-gray-200 bg-gray-50 px-3 py-1.5">
      <span className="text-xs text-gray-500">
        {limitInfo.provider} &middot; recommended: {limitInfo.recommendedChars.toLocaleString()}{" "}
        chars ({limitInfo.label})
      </span>
      <span className={cn("text-xs font-medium tabular-nums", getCountColor())}>
        {charCount.toLocaleString()} / {limitInfo.recommendedChars.toLocaleString()}
      </span>
    </div>
  );
};
